import { REGEX } from "@constants/regex";

/**
 * Format currency amount to Indian Rupee format
 * @param {number} amount - Amount to format
 * @param {string} locale - Locale for formatting (default: 'en-IN')
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, locale = "en-IN") => {
  return `₹ ${amount?.toLocaleString(locale) || 0}`;
};

export const validateAmount = (value) => {
  return value === "" || REGEX.DECIMAL_AMOUNT.test(value);
};
